/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S5_Form_TemplateInputs */

const tr_kvkkbasvuru_s5_form_template = /** @type {(inputs: Kvkkbasvuru_S5_Form_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi
Veri Sorumlusu

Ad-Soyad      : ________________________________
TCKN / Pasaport: ______________________________
Adres         : ________________________________
E-posta       : ________________________________
Telefon       : ________________________________

Talep konusu (KVKK Madde 11 kapsamında):
 [ ] Kişisel verilerimin işlenip işlenmediğini öğrenmek istiyorum
 [ ] İşlenmiş kişisel verilerim hakkında bilgi talep ediyorum
 [ ] İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenmek istiyorum
 [ ] Yurtiçi / yurtdışında aktarıldığı üçüncü kişileri bilmek istiyorum
 [ ] Eksik / yanlış işlenen verilerin düzeltilmesini talep ediyorum
 [ ] KVKK Madde 7 kapsamında silinmesini / yok edilmesini talep ediyorum
 [ ] Otomatik sistemlerle analiz sonucuna itiraz ediyorum
 [ ] Kanuna aykırı işlenmeden kaynaklanan zararın giderilmesini talep ediyorum

Talebinizin detayı ve ek belgeler:
________________________________________________
________________________________________________

Tarih: __________       İmza: __________`)
};

const en_kvkkbasvuru_s5_form_template = /** @type {(inputs: Kvkkbasvuru_S5_Form_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi
Veri Sorumlusu (data controller)

Name-Surname    : ______________________________
TCKN / Passport : ______________________________
Address         : ______________________________
Email           : ______________________________
Phone           : ______________________________

Subject of the request (under KVKK Article 11):
 [ ] I want to learn whether my personal data is processed
 [ ] I request information about my processed personal data
 [ ] I want to learn the purpose of processing and whether the data is used in line with that purpose
 [ ] I want to know the third parties in Turkey / abroad to whom the data has been transferred
 [ ] I request rectification of incompletely / incorrectly processed data
 [ ] I request erasure / destruction under KVKK Article 7
 [ ] I object to the result of analysis by automated systems
 [ ] I demand compensation for damage arising from unlawful processing

Details of your request and additional documents:
________________________________________________
________________________________________________

Date: __________       Signature: __________`)
};

const de_kvkkbasvuru_s5_form_template = /** @type {(inputs: Kvkkbasvuru_S5_Form_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi
Veri Sorumlusu (Verantwortlicher)

Vor- und Nachname : ______________________________
TCKN / Reisepass  : ______________________________
Adresse           : ______________________________
E-Mail            : ______________________________
Telefon           : ______________________________

Gegenstand des Anliegens (nach KVKK Artikel 11):
 [ ] Ich möchte erfahren, ob meine personenbezogenen Daten verarbeitet werden
 [ ] Ich verlange Auskunft über meine verarbeiteten personenbezogenen Daten
 [ ] Ich möchte den Verarbeitungszweck erfahren und ob die Daten zweckentsprechend verwendet werden
 [ ] Ich möchte die Dritten im Inland / Ausland kennen, an die die Daten übermittelt wurden
 [ ] Ich verlange die Berichtigung unvollständig / unrichtig verarbeiteter Daten
 [ ] Ich verlange die Löschung / Vernichtung nach KVKK Artikel 7
 [ ] Ich widerspreche dem Ergebnis der Analyse durch automatisierte Systeme
 [ ] Ich verlange den Ersatz des Schadens aus gesetzwidriger Verarbeitung

Einzelheiten Ihres Anliegens und weitere Unterlagen:
________________________________________________
________________________________________________

Datum: __________       Unterschrift: __________`)
};

const ru_kvkkbasvuru_s5_form_template = /** @type {(inputs: Kvkkbasvuru_S5_Form_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi
Veri Sorumlusu (ответственный за данные)

Имя и фамилия  : ______________________________
TCKN / паспорт : ______________________________
Адрес          : ______________________________
Эл. почта      : ______________________________
Телефон        : ______________________________

Предмет требования (в рамках статьи 11 KVKK):
 [ ] Хочу узнать, обрабатываются ли мои персональные данные
 [ ] Запрашиваю информацию об обработанных персональных данных
 [ ] Хочу узнать цель обработки и используются ли данные в соответствии с этой целью
 [ ] Хочу знать третьих лиц внутри страны / за рубежом, которым были переданы данные
 [ ] Требую исправления неполно / неверно обработанных данных
 [ ] Требую удаления / уничтожения в рамках статьи 7 KVKK
 [ ] Возражаю против результата анализа автоматизированными системами
 [ ] Требую возмещения ущерба, возникшего вследствие незаконной обработки

Подробности вашего требования и приложенные документы:
________________________________________________
________________________________________________

Дата: __________       Подпись: __________`)
};

/**
* | output |
* | --- |
* | "Emonse® E-Ticaret Limited Şirketi Veri Sorumlusu (data controller) Name-Surname : ______________________________ TCKN / Passport : __________________________..." |
*
* @param {Kvkkbasvuru_S5_Form_TemplateInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s5_form_template = /** @type {((inputs?: Kvkkbasvuru_S5_Form_TemplateInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S5_Form_TemplateInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s5_form_template(inputs)
	if (locale === "de") return de_kvkkbasvuru_s5_form_template(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s5_form_template(inputs)
	return tr_kvkkbasvuru_s5_form_template(inputs)
});